module.exports = __webpack_public_path__ + "static/media/screenshot_6.78a64e41.png";